import React from 'react';
import styled, { keyframes } from 'styled-components';

const ellipsisAnimation = keyframes`
to{
    clip-path: inset(0);
}
`;

const EllipsisContainer = styled.div`
  font-weight: 600;
  display: inline-flex;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  clip-path: inset(0 3ch 0 0);
  animation: ${ellipsisAnimation} 0.1s steps(4, jump-none) infinite;
`;

const EllipsisAnimation = () => <EllipsisContainer>...</EllipsisContainer>;

export default EllipsisAnimation;
